import React from "react";
import Tooltip from "react-native-walkthrough-tooltip";
import { AppColors } from "../../../utility/AppColors";
import {
  Image,
  Text,
  TouchableHighlight,
  TouchableOpacity,
  View,
} from "react-native";
import ImageComponent from "../../ImageComponent";
import { AppImages } from "../../../utility/AppImages";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { useTooltips } from "../../../context/WalkthroughContext";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Separator from "../../Separator";
import CreateEventComponent from "../../home-common-components/CreateEventComponent";
import { CropImage } from "../../choose-avatar-components/CropImage";
import Avatar from "../../choose-avatar-components/Avatar";

const SignUpWalkthrough = () => {
  const {
    signupEventTooltipVisible,
    setSignupEventTooltipVisible,
    setHomeWalkThroughVisible,
    currentStep,
    totalSteps,
    setTicketEventTooltipVisible,
    handleNextStep,
  } = useTooltips();
  const deviceSize = useDeviceSize();

  return (
    <Tooltip
      isVisible={signupEventTooltipVisible}
      contentStyle={{
        backgroundColor: AppColors.purple_453B50,
        width:
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? 350
            : 736,
        borderColor: AppColors.white,
        shadowColor: "rgba(255, 255, 255, 0.65)",
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.65,
        shadowRadius: 10.1,
        elevation: 5,
        borderWidth: 1,
      }}
      displayInsets={{
        top: 100,
        bottom:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? 0
            : 400,
        left:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? 0
            : deviceSize === DEVICE_SIZES.MD
            ? 50
            : 100,
        right: 0,
      }}
      arrowStyle={{
        display: "none",
      }}
      content={
        <View>
          <View
            style={{
              flexDirection:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? "column"
                  : "row",
              gap: 10,
            }}
          >
            <TouchableOpacity
              onPress={() => {
                setHomeWalkThroughVisible(false);
                setSignupEventTooltipVisible(false);
              }}
              style={{ position: "absolute", right: 0, top: 0, zIndex: 1 }}
            >
              <ImageComponent
                url={AppImages.icCloseWhiteSvg}
                style={{
                  height: 16,
                  width: 16,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
            <View
              style={{
                gap: 10,
                alignItems:
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? "center"
                    : "flex-start",
                ...(deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM
                  ? { flexDirection: "row" }
                  : { width: "25%" }),
              }}
            >
              <View style={{ gap: 8 }}>
                <Avatar
                  src="https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                  variant="walkthroughPlayer"
                />
                {deviceSize === DEVICE_SIZES.XS ||
                  (deviceSize === DEVICE_SIZES.SM ? null : (
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { lineHeight: 21 },
                      ]}
                    >
                      <Text style={{ color: AppColors.green_00FFE8 }}>
                        Pro Tip :{" "}
                      </Text>
                      Check out subscription options to unlock perks, reduced
                      fees, and priority profile placement!
                    </Text>
                  ))}
              </View>
              {deviceSize === DEVICE_SIZES.XS ||
              deviceSize === DEVICE_SIZES.SM ? (
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_12,
                    { color: AppColors.white },
                  ]}
                >
                  Sign Up & Get in the Action 🔥
                </Text>
              ) : null}
            </View>
            <View
              style={{
                flex: 1,
                marginTop:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 0
                    : 12,
              }}
            >
              <View style={{ gap: 10 }}>
                {deviceSize === DEVICE_SIZES.XS ||
                deviceSize === DEVICE_SIZES.SM ? null : (
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_16,
                      { color: AppColors.white }, // Set text color for better readability
                    ]}
                  >
                    Sign Up & Get in the Action 🔥
                  </Text>
                )}
                <View>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { lineHeight: 21 },
                    ]}
                  >
                    Get instant access to free KallOut Events—watch live
                    battles, engage in chat, and see players go head-to-head.
                  </Text>
                  <View>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { lineHeight: 21 },
                      ]}
                    >
                      <Text style={{ color: AppColors.green_00FFE8 }}>
                        Watch for Free :{" "}
                      </Text>
                      Sign up and jump into any KallOut Event—no ticket
                      required.
                    </Text>

                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { lineHeight: 21 },
                      ]}
                    >
                      <Text style={{ color: AppColors.green_00FFE8 }}>
                        Engage in Real-Time :{" "}
                      </Text>
                      Chat with players, hype up the competition, and be part of
                      the action.
                    </Text>

                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { lineHeight: 21 },
                      ]}
                    >
                      <Text style={{ color: AppColors.green_00FFE8 }}>
                        Track & Build Your Profile :{" "}
                      </Text>
                      Follow players, check stats, and stay in the loop.
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          </View>
          <View
            style={{
              gap: 10,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              marginTop: 10,
            }}
          >
            <Text
              style={{
                ...AppFontStyle.REGULAR_ANYBODY_12,
                color: AppColors.green_00FFE8,
              }}
            >
              {currentStep + 1} / {totalSteps}
            </Text>

            <TouchableOpacity
              onPress={() => {
                setSignupEventTooltipVisible(false);
                // if (firstGetTicketIndex === -1) {
                //   setSidebarTopTooltipVisible(true);
                // } else {
                setTicketEventTooltipVisible(true);
                // }
                handleNextStep();
              }}
              style={{
                backgroundColor: AppColors.appViolentColor_6D08C3,
                width: 70,
                height: 20,
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 10,
                cursor: "pointer",
                shadowColor: "rgba(0, 0, 0, 0.25)",
                shadowOffset: { width: 0, height: 4 },
                shadowOpacity: 0.25,
                shadowRadius: 4,
                elevation: 4,
              }}
            >
              <Text style={AppFontStyle.BOLD_ANYBODY_12}>Next</Text>
            </TouchableOpacity>
          </View>
        </View>
      }
      placement="top"
    ></Tooltip>
  );
};

export default SignUpWalkthrough;
